import { Box } from '@chakra-ui/react';
import { InfoWindow, Marker } from '@react-google-maps/api';
import { IDealer } from 'interfaces/dealer.interface';
import React, { useEffect } from 'react';

type AgentItemMarkerProps = {
  dealer: IDealer;
  showInfoWindow?: boolean;
  onClick: (dealer: IDealer) => void;
  onInfoWindowClose: () => void;
};

function AgentItemMarker({
  dealer,
  showInfoWindow = false,
  onClick,
  onInfoWindowClose,
}: AgentItemMarkerProps) {
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);

  const [isMarkerClicked, setIsMarkerClicked] = React.useState<boolean>(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (showInfoWindow) {
      setIsMarkerClicked(true);
    }
  }, [showInfoWindow]);

  const handleMarkerClick = () => {
    setIsMarkerClicked(true);
    onClick(dealer);
  };

  return isLoaded ? (
    <Marker
      key={dealer.id}
      position={{
        lat: dealer.latitude,
        lng: dealer.longitude,
      }}
      onClick={handleMarkerClick}
    >
      {isMarkerClicked && dealer.name && (
        <InfoWindow
          position={{
            lat: dealer.latitude,
            lng: dealer.longitude,
          }}
          onCloseClick={() => {
            setIsMarkerClicked(false);
            onInfoWindowClose();
          }}
        >
          <Box>
            <Box>{dealer.name}</Box>
          </Box>
        </InfoWindow>
      )}
    </Marker>
  ) : null;
}

export default AgentItemMarker;
